/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationSection } from '@squiz/sds';
import { DXP_MENU_MONITORING_SCREENS } from './NavItems.constants';
import { MONITORING_STRINGS } from './Strings.constants';

/**
 * The main navigation menu section for Monitoring screens.
 */
export const DXP_MENU_MONITORING_SECTION: NavigationSection = {
  items: DXP_MENU_MONITORING_SCREENS,
  key: `menu-section-monitoring`,
  label: MONITORING_STRINGS.logs,
  showLabel: false,
};
